import React, { useState } from "react";

import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";

import { ButtonVariant } from "Constant/button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";

import StandartButton from "components/atoms/StandartButton";
import useHostFooterAction from "components/organisms/CreationModal/hooks/useHostFooterAction";

import "../../css/createSourceModal.css";
import { sendLeadsquaredData } from "../../helpers/Sources/leadsquared/leadsquared";
import CrmSourceMappingArea from "../CrmSourceMappingArea";
import SwalAlertComp from "../SwalAlert";

const LeadsquaredSource = (props) => {
    const { useHostFooter = false, registerFooterAction } = props;
    const [leadsquaredInput, setLeadsquaredSaleInput] = useState({
        name: "",
        crm_domain: "",
        access_key: "",
        secret_key: "",
    });
    const [leadsquaredSourceID, setLeadsquaredSourceID] = useState("");
    const [btnCheck, setBtnCheck] = useState(true);
    const [leadsquaredData, setLeadsquaredData] = useState(null);
    const [errorMessages, setErrorMessages] = useState({
        name: "",
        crm_domain: "",
        access_key: "",
        secret_key: "",
    });
    const [isLoading, setIsLoading] = useState(false);
    const language = useSelector((state) => state.languagesState.languages);

    const handleCloseModal = () => {
        props?.handleClose();
        setBtnCheck(false);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setLeadsquaredSaleInput({ ...leadsquaredInput, [name]: value });
        setErrorMessages({
            ...errorMessages,
            [name]: value ? "" : "Cannot be blank!",
        });
    };

    const fetchLeadsquaredData = async () => {
        setIsLoading(true);
        if (
            !leadsquaredInput.name ||
            !leadsquaredInput.crm_domain ||
            !leadsquaredInput.access_key ||
            !leadsquaredInput.secret_key
        ) {
            setErrorMessages({
                name:
                    leadsquaredInput.name === ""
                        ? (language?.tracker_wizard?.cannot_be_blank ??
                          "Cannot be blank!")
                        : "",
                crm_domain:
                    leadsquaredInput.crm_domain === ""
                        ? (language?.tracker_wizard?.cannot_be_blank ??
                          "Cannot be blank!")
                        : "",
                access_key:
                    leadsquaredInput.access_key === ""
                        ? (language?.tracker_wizard?.cannot_be_blank ??
                          "Cannot be blank!")
                        : "",
                secret_key:
                    leadsquaredInput.secret_key === ""
                        ? (language?.tracker_wizard?.cannot_be_blank ??
                          "Cannot be blank!")
                        : "",
            });
        } else {
            if (props?.setLoading !== undefined) {
                props?.setLoading(true);
            }
            let data = {
                name: leadsquaredInput?.name,
                crm_domain: leadsquaredInput?.crm_domain,
                accessKey: leadsquaredInput?.access_key,
                secretKey: leadsquaredInput?.secret_key,
                usage_types: [4],
            };
            let response = await sendLeadsquaredData(data);
            if (response.status) {
                setLeadsquaredData(response?.data?.field_data?.fields);
                if (props.selectFileSourceId) {
                    props.selectFileSourceId(
                        response?.data?.source?.id,
                        response?.data?.source?.source_type_id,
                    );
                }
                setBtnCheck(false);
                setLeadsquaredSourceID(response?.data?.source?.id);
                if (props?.setLoading !== undefined) {
                    props?.setLoading(false);
                }
            } else {
                SwalAlertComp({
                    title: language?.delete_swal_modal?.failed ?? "Failed",
                    message: response?.message ?? "",
                    icon: "error",
                });
                if (props?.setLoading !== undefined) {
                    props?.setLoading(false);
                }
            }
        }
        setIsLoading(false);
    };

    const saveCrmMapping = (response) => {
        props?.setIsMappingSuccessfull(true);
        if (props?.setLoading !== undefined) {
            props?.setLoading(true);
        }
        if (response.status) {
            if (props?.setLoading !== undefined) {
                props?.setLoading(false);
            }
            SwalAlertComp({
                title: language?.delete_swal_modal?.success ?? "Success",
                message: response.message && response.message,
                icon: "success",
                timer: 3000,
            });
            props?.handleClose(leadsquaredSourceID);
            if (props.handleGetSources) {
                props.handleGetSources();
            }
            if (props.getTracker) {
                props.addToTracker(leadsquaredSourceID);
            }
            if (props.getAllSourcesReduxProps) {
                props.getAllSourcesReduxProps();
            }
            if (props.setNextCheck) {
                props.setNextCheck(true);
            }
            setLeadsquaredSourceID("");
            setBtnCheck(false);
        } else {
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response?.message ?? "",
                icon: "error",
            });
            if (props?.setLoading !== undefined) {
                props?.setLoading(false);
            }
        }
    };

    useHostFooterAction(registerFooterAction, "form", {
        label: language?.buttons?.continue ?? "Continue",
        onSubmit: fetchLeadsquaredData,
        isLoading,
        hidden: !!leadsquaredData,
    });

    return (
        <div>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                {leadsquaredData ? (
                    <>
                        <CrmSourceMappingArea
                            sourceId={leadsquaredSourceID}
                            sourceType={"lsqrd"}
                            mappingSuccess={saveCrmMapping}
                            isModal={props?.isModal}
                            hideSaveButton={useHostFooter}
                            registerFooterAction={registerFooterAction}
                        ></CrmSourceMappingArea>
                    </>
                ) : (
                    <>
                        <FormControl
                            className="mb-3"
                            style={{ width: "100%" }}
                            error={errorMessages.name === null}
                        >
                            <TextField
                                name="name"
                                label={language?.source_modal?.name ?? "Name"}
                                variant="outlined"
                                onChange={handleInputChange}
                                placeholder={
                                    language?.source_modal?.please_write_name ??
                                    "Please Write Name"
                                }
                                value={leadsquaredInput?.name}
                                required
                                error={errorMessages.name === null}
                            />
                            {errorMessages?.name && (
                                <div className="fileUploadStyle">
                                    {errorMessages?.name}
                                </div>
                            )}
                        </FormControl>

                        <FormControl
                            className="mb-3"
                            style={{ width: "100%" }}
                            error={errorMessages.crm_domain === null}
                        >
                            <TextField
                                name="crm_domain"
                                label={
                                    language?.source_modal?.crm_domain ??
                                    "Domain"
                                }
                                variant="outlined"
                                onChange={handleInputChange}
                                placeholder={
                                    language?.source_modal
                                        ?.please_write_crm_domain ??
                                    "Please Write Domain"
                                }
                                value={leadsquaredInput?.crm_domain}
                                required
                                error={errorMessages.crm_domain === null}
                            />
                            {errorMessages?.crm_domain && (
                                <div className="fileUploadStyle">
                                    {errorMessages?.crm_domain}
                                </div>
                            )}
                        </FormControl>

                        <FormControl
                            className="mb-3"
                            style={{ width: "100%" }}
                            error={errorMessages.access_key === null}
                        >
                            <TextField
                                name="access_key"
                                label={
                                    language?.source_modal?.access_key ??
                                    "Access Key"
                                }
                                variant="outlined"
                                onChange={handleInputChange}
                                placeholder={
                                    language?.source_modal
                                        ?.please_write_access_key ??
                                    "Please Write Access Key"
                                }
                                value={leadsquaredInput?.access_key}
                                required
                                error={errorMessages.access_key === null}
                            />
                            {errorMessages?.access_key && (
                                <div className="fileUploadStyle">
                                    {errorMessages?.access_key}
                                </div>
                            )}
                        </FormControl>

                        <FormControl
                            className="mb-3"
                            style={{ width: "100%" }}
                            error={errorMessages.secret_key === null}
                        >
                            <TextField
                                name="secret_key"
                                label={
                                    language?.source_modal?.secret_key ??
                                    "Secret Key"
                                }
                                variant="outlined"
                                onChange={handleInputChange}
                                placeholder={
                                    language?.source_modal
                                        ?.please_write_secret_key ??
                                    "Please Write Secret Key"
                                }
                                value={leadsquaredInput?.secret_key}
                                required
                                error={errorMessages.secret_key === null}
                            />
                            {errorMessages?.secret_key && (
                                <div className="fileUploadStyle">
                                    {errorMessages?.secret_key}
                                </div>
                            )}
                        </FormControl>
                    </>
                )}
            </Form.Group>

            {!useHostFooter && btnCheck && (
                <Modal.Footer className="source-modal-footer d-flex justify-content-between">
                    <StandartButton
                        variant={ButtonVariant.BLACK_OUTLINED}
                        onClick={handleCloseModal}
                    >
                        {language?.buttons?.close ?? "Close"}
                    </StandartButton>
                    <StandartButton
                        variant="contained"
                        color="primary"
                        onClick={fetchLeadsquaredData}
                        isLoading={isLoading}
                    >
                        {language?.buttons?.create_source ?? "Create Source"}
                    </StandartButton>
                </Modal.Footer>
            )}
        </div>
    );
};

export default LeadsquaredSource;
